import { useTranslation } from 'react-i18next'

import { RENTAL_PORTAL_LISTING_STATUSES } from '../../../constants/rentalPortal'
import { EntityStatus } from '../../Entity'
import { ICON_HEIGHT_16, IconNG } from '../../Icon'
import { Status } from '../../Status'
import { LISTING_STATUS_BADGE_WARNING_ICON_COLOR } from '../RentalPortalListing.constants'
import { getListingStatusBadge } from '../RentalPortalListing.utils'

import * as styles from './RentalPortalListingStatusBadge.module.css'

import ErrorIcon from '../../../icons/error.svg'

function RentalPortalListingStatusBadge({
  className,
  height,
  listing,
  textClassName,
}) {
  const { t } = useTranslation()

  const badge = getListingStatusBadge({ listing, t })

  return badge ? (
    <span className={styles.RentalPortalListingStatusBadge}>
      {badge.isWarning ? (
        <IconNG
          Icon={ErrorIcon}
          color={LISTING_STATUS_BADGE_WARNING_ICON_COLOR}
          size={ICON_HEIGHT_16}
        />
      ) : null}
      <Status
        className={className}
        height={height}
        text={badge.label}
        textClassName={textClassName}
        textColor={badge.textColor}
      />
    </span>
  ) : (
    <EntityStatus
      className={className}
      height={height}
      id={listing?.status}
      statuses={RENTAL_PORTAL_LISTING_STATUSES}
      textClassName={textClassName}
    />
  )
}

export default RentalPortalListingStatusBadge
